export default{snackbar:"w_GS",transitionEnter:"w_GT",transitionEnterActive:"w_GU",transitionExit:"w_GV",transitionExitActive:"w_GW",snackContainer:"w_GX",snack:"w_GY"};
